import { IChartSeries } from "@mais-retorno-front/models/chart-serie";

interface IProfitQuotes {
  nicename: string;
  id: string;
  color?: string;
  quotes: IQuotes[];
}

interface IQuotes {
  c: number;
  d: number;
}

export const createProfitSeries = (
  assetsQuotes: IProfitQuotes[]
): IChartSeries[] => {
  
  return assetsQuotes.map((asset) => {
    return {
      name: asset.nicename,
      id: asset.id,
      color: asset.color,
      type: 'line',
      data: asset.quotes.map(({ d, c }) => [d, c]),
    };
  });
};
